import { create } from "zustand";

const useBatchTrackingStore = create((set) => ({
  isBatchTrackingEnabled: false,
  stockMovementMethod: null,

  setBatchTrackingConfig: ({ isBatchTrackingEnabled, stockMovementMethod }) => {
    set({
      isBatchTrackingEnabled: !!isBatchTrackingEnabled,
      stockMovementMethod: stockMovementMethod || null,
    });
  },

  clearBatchTrackingConfig: () =>
    set({
      isBatchTrackingEnabled: false,
      stockMovementMethod: null,
    }),
}));

export default useBatchTrackingStore;
